import React, { useEffect, useState } from "react";
import { Paper, Typography, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const VerifyEmailPage = ({ serverUrl }) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [status, setStatus] = useState({
    loading: Boolean(token),
    message: "",
    success: false,
  });

  useEffect(() => {
    if (!token) {
      return;
    }
    setStatus({ loading: true, message: "", success: false });
    axios
      .get(`${serverUrl}/verify-email`, { params: { token } })
      .then((res) =>
        setStatus({
          loading: false,
          message: res?.data?.message || t("verifyEmailSuccess"),
          success: true,
        })
      )
      .catch((error) => {
        const message =
          error?.response?.data?.message || t("verifyEmailError");
        setStatus({ loading: false, message, success: false });
      });
  }, [serverUrl, t, token]);

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        {t("verifyEmailTitle")}
      </Typography>
      {!token ? (
        <Typography variant="body2" color="text.secondary">
          {t("verifyEmailMissingToken")}
        </Typography>
      ) : status.loading ? (
        <CircularProgress />
      ) : (
        <Typography
          variant="body1"
          sx={{ color: status.success ? "success.main" : "error.main" }}
        >
          {status.message}
        </Typography>
      )}
    </Paper>
  );
};

export default VerifyEmailPage;
